import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CheckinsService {

  constructor(private http: HttpClient) { }

  create(accoundId, checkin) {
    return this.http.post(`/api/accounts/${accoundId}/checkins`, checkin);
  }

  delete(accountId, checkinId) {
    return this.http.delete(`/api/accounts/${accountId}/checkins/${checkinId}`);
  }

  export(data) {
    return this.http.post('/api/accounts/checkins/export', data);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/checkins/checkins.service.ts